import React, { Suspense } from 'react'
import {
	Route,
	createBrowserRouter,
	createRoutesFromElements,
	RouterProvider,
	Navigate,
} from 'react-router-dom'

import 'antd/dist/reset.css'

import useChannelTalkService from './hooks/channelTalk/useChannelTalkService'

import MainLayout from './components/layouts/MainLayout'
import GlobalStyle from '@src/styles/GlobalStyle'

import SignupPage from './pages/SignupPage'
import SigninPage from './pages/SigninPage'
import ProductRegistrationPage from './pages/product/ProductRegistrationPage'
import ProductEditPage from './pages/product/ProductEditPage'
import ProductListPage from './pages/product/ProductListPage'
import ProductDetailPage from './pages/product/ProductDetailPage'
import OrderListPage from './pages/order/OrderListPage'
import { HotdealChallengeRegistrationPage } from './pages/challenge/HotdealChallengeRegistrationPage'
import { ChallengeListPage } from './pages/challenge/ChallengeListPage'
import { PlanAndPaymentLayout, PlanPage, PaymentInfoPage } from './pages/payment/PlanAndPayment'
import { HomePage } from './pages/home'
import BrandProfilePage from './pages/brand/BrandProfilePage'

import TestComponent from './components/TestComponent/TestComponent'

import { RefundList } from './pages/RefundList'

const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			<Route path="/" element={<MainLayout />}>
				<Route path="/" element={<HomePage />} />
				<Route
					path="/challenge/hotdeal-registration"
					element={<HotdealChallengeRegistrationPage />}
				/>
				<Route path="/challenge" element={<ChallengeListPage />} />
				<Route path="/product/registration" element={<ProductRegistrationPage />} />
				<Route path="/product/:productNo/edit" element={<ProductEditPage />} />
				<Route path="/product" element={<ProductListPage />} />
				<Route path="/product/:productNo" element={<ProductDetailPage />} />
				<Route path="/order" element={<OrderListPage />} />
				<Route path="/refund" element={<RefundList />} />

				<Route
					path="/vendor/profile"
					element={
						<Suspense fallback={<div>데이터 받아오는 중~</div>}>
							<BrandProfilePage />
						</Suspense>
					}
				/>

				<Route path="/payment/subscribe" element={<PlanAndPaymentLayout />}>
					<Route
						path="/payment/subscribe"
						element={<Navigate to="/payment/subscribe/plan" replace />}
					/>
					<Route path="/payment/subscribe/plan" element={<PlanPage />} />
					<Route path="/payment/subscribe/info" element={<PaymentInfoPage />} />
				</Route>
			</Route>
			<Route path="/signup" element={<SignupPage />} />
			<Route path="/signin" element={<SigninPage />} />
			<Route path="/test" element={<TestComponent />} />
		</>,
	),
)

const App = () => {
	useChannelTalkService()

	return (
		<>
			<RouterProvider router={router} />
			<GlobalStyle />
		</>
	)
}

export default App
